<app-wrapper>
  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Бармен
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="save()" [disabled]="form.invalid" class="btn btn-primary">
            <i class="fa-solid fa-save"></i>&nbsp;Сохранить
          </button>
        </div>
      </div>
    </div>
    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <div class="row">
            <div class="col-md-6 col-lg-3 mb-4">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input type="text" name="lastName" [(ngModel)]="model.lastName" class="form-control"
                    required placeholder="Фамилия">
                    <label>Фамилия</label>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 mb-4">
                <div class="form-group">
                  <div class="form-floating mb-3">
                    <input type="text" name="name" [(ngModel)]="model.name" class="form-control"
                      required placeholder="Имя">
                      <label>Имя</label>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mb-4">
                  <div class="form-group">
                    <div class="form-floating mb-3">
                      <select name="parentId" [(ngModel)]="model.store!.id" class="form-select"
                        placeholder="Выберите категорию">
                        @for (item of stores; track item) {
                          <option [value]="item.id">
                            {{ item.name }} ({{item.address}})
                          </option>
                        }
                      </select>
                      <label>Магазин</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3 mb-4">
                  <div class="form-group">
                    <div class="form-floating mb-3">
                      <input type="url" name="tipsLink" [(ngModel)]="model.tipsLink" class="form-control"
                        placeholder="Чаевые">
                        <label>Ссылка для чаевых</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="file-container">
                      <div class="file-square" [ngStyle]="getImageStyle()">
                        <input type="file" id="docs" accept="image/*" (change)="selectFile($event)" />
                        <label for="docs">
                          <i class="fa-solid fa-plus"></i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-4">
                    <div class="form-group">
                      <div class="form-floating mb-3">
                        <textarea [(ngModel)]="model.description" name="description" placeholder="Описание"
                        required rows="5" class="form-control"></textarea>
                        <label>
                          Описание
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        @if (isBusy) {
          <div class="overlay">
            <i class="fa-solid fa-spinner fa-spin"></i>
          </div>
        }
      </app-wrapper>